import { Component, EventEmitter, Output } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { StatusComponent } from '../../../../ui/status/status.component';
import { PromptCardComponent } from '../../../../toasts-and-cards/prompt-card/prompt-card.component';
import { UpdateScheduleComponent } from '../update-schedule/update-schedule.component';
import { EngagementMessageSchedule } from '../../../../../pages/organization/campaigns/types/messagesTypes';
import { formatCountdown, formatWhen } from '../../../../../../utils/sms';
import { scheduleMoment } from '../../../../../pages/organization/campaigns/campaign-details/campaign-sends';

@Component({
  selector: 'app-message-schedules',
  standalone: true,
  imports: [MatTooltipModule, StatusComponent, PromptCardComponent, UpdateScheduleComponent],
  templateUrl: './message-schedules.component.html',
  styleUrl: '../../campaign-form.css',
})
export class MessageSchedulesComponent {
  editSchedule = false;
  deleteSchedule = false;
  scheduleToEditData: any = {};
  schedulesData: EngagementMessageSchedule[] = [];
  @Output() onGetSchedules = new EventEmitter();

  /** The schedules so far, soonest first. */
  get rows() {
    const now = new Date();
    return this.schedulesData
      .map((schedule) => {
        const at = scheduleMoment(schedule);
        return {
          id: schedule.id,
          at: at?.getTime() ?? Infinity,
          when: formatWhen(at, now),
          sub: [formatCountdown(at, now), schedule.scheduleTimeZone ?? ''].filter(Boolean).join(' · '),
        };
      })
      .sort((a, b) => a.at - b.at);
  }
  editingSchedule(id: number) {
    // set schedule data passed to edit component
    this.scheduleToEditData = this.schedulesData.find(
      (item) => item.id === id
    ) as EngagementMessageSchedule;
    this.editSchedule = true;
  }

  addSchedule() {
    // clear schedule data passed to edit schedule component so that component is not prepopulated
    this.scheduleToEditData = {};
    this.editSchedule = true;
  }

  handleGetSchedule(schedule: EngagementMessageSchedule) {
    // check schedules data if this schedule already exist
    const scheduleToEdit = this.schedulesData.some(
      (item) => item.id == schedule?.id
    );

    if (scheduleToEdit) {
      // replace the item id with the new schedule
      this.schedulesData = this.schedulesData.map((item) => {
        if (item.id === schedule.id) {
          return schedule;
        }
        return item;
      });
    }
    // else push new schedule with a unique id
    else {
      this.schedulesData.push({
        id: this.generateUniqueId(
          this.schedulesData.map((item) => {
            return { id: item.id };
          })
        ),
        scheduleDate: schedule.scheduleDate,
        scheduleTime: schedule.scheduleTime,
        scheduleTimeZone: schedule.scheduleTimeZone,
        engagementMessages: [],
        status: schedule.status,
      });
    }
    // Emit schedules data to parent component (create message component)
    this.onGetSchedules.emit(this.schedulesData);
  }

  scheduleToDeleteId: number | null = null;

  showDeletePrompt(id: number) {
    this.scheduleToDeleteId = id;
    this.deleteSchedule = true;
  }

  handleDeleteSchedule() {
    this.schedulesData = this.schedulesData.filter(
      (item) => item.id !== this.scheduleToDeleteId
    );
    this.scheduleToDeleteId = null;
    this.deleteSchedule = false;
    // Tell the parent too, so a deleted schedule is not sent with the message.
    this.onGetSchedules.emit(this.schedulesData);
  }

  // function for random id generator
  generateUniqueId(
    existingObjects: { id: number }[],
    maxAttempts = 100
  ): number {
    const generateRandomId = () => Math.floor(Math.random() * 1000); // Generate random ID in a range, e.g., 0 to 999,999

    let newId: number;
    let attempts = 0;

    do {
      if (attempts >= maxAttempts) {
        throw new Error('Unable to generate a unique ID after max attempts.');
      }

      newId = generateRandomId();
      attempts++;
    } while (existingObjects.some((obj) => obj.id === newId));

    return newId;
  }
}
